module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h4', {
    staticClass: "h4"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/06_9781614230755_Foreword"
    }
  }, [_vm._v("Foreword, by Raymond O. Polett")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/07_9781614230755_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/08_9781614230755_Introduction"
    }
  }, [_vm._v("Introduction, by Paul Ewasko and Lisa Caputo")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-a"
  }, [_c('a', {
    attrs: {
      "href": "#/09_9781614230755_CH01"
    }
  }, [_vm._v("A Bridge So Close, So Far")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/10_9781614230755_CH02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Search of Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/11_9781614230755_CH03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Safe in America")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/12_9781614230755_CH04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Drive to Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/13_9781614230755_CH05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigation to Nowhere, Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/14_9781614230755_CH06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Niece, a Reporter and a PI")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/15_9781614230755_CH07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Investigation to Nowhere, Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-a"
  }, [_c('span', {
    attrs: {
      "href": "#/16_9781614230755_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/17_9781614230755_AppendixA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A. Family Letter to New York Governor George E. Pataki")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/18_9781614230755_AppendixB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B. Letters to David Hennigan")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/19_9781614230755_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89e7b378","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_9781614230755_Contents.vue
// module id = 69
// module chunks = 0